import styled, { css } from 'styled-components';
import CheckImg from 'assets/img/icons/checkmark.svg';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledStepper = styled.div`
  position: relative;
  display: flex;
  margin: 0 6px;

  :last-child {
    flex: 0;
  }

  @media ${sizes.desktop} {
    flex-direction: column;
    height: 450px;
    width: 6px;
  }
`;

export const Step = styled.div`
  position: relative;
  flex: 1;
  height: 6px;
  background-color: #3babac;

  :first-child {
    flex: 0;
  }

  ::after {
    content: ' ';
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ $selected }) =>
      $selected ? th('colors.yellow') : th('colors.silverLightGray')};
    z-index: 2;
    transition: background-color 100ms;

    @media ${sizes.desktop} {
      top: initial;
      bottom: 0;
      left: -3px;
      transform: none;
    }

    ${({ $isDone }) =>
      $isDone &&
      css`
        right: -10px;
        width: 20px;
        height: 20px;
        border-radius: 5px;
        background-color: ${th('colors.white')};
        background-image: url(${CheckImg});
        background-size: 80%;
        background-position: 25% center;
        background-repeat: no-repeat;
        box-shadow: ${th('shadows.small')};

        @media ${sizes.desktop} {
          left: -7px;
          bottom: -2px;
        }
      `}
  }
`;

export const ProgressIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ completionPercentage }) => `${completionPercentage}%`};
  height: 6px;
  background-color: ${th('colors.blue')};
  z-index: 1;

  @media ${sizes.desktop} {
    height: ${({ completionPercentage }) => `${completionPercentage}%`};
    width: 6px;
  }
`;

export const StepLabel = styled.div`
  display: none;
  position: absolute;
  bottom: -3px;
  left: 26px;
  font-size: 14px;
  white-space: nowrap;
  color: ${th('colors.black')}80;
  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
  transition: color 100ms, font-weight 100ms;
  cursor: ${({ $isDone }) => ($isDone ? 'pointer' : 'initial')};

  ${({ $selected, $isDone }) =>
    ($selected || $isDone) &&
    css`
      color: ${th('colors.black')};
    `};

  @media ${sizes.desktop} {
    display: block;
  }
`;

export const SubSteps = styled.ul`
  display: none;
  position: absolute;
  top: 100%;
  margin-top: 0;

  @media ${sizes.desktop} {
    display: block;
  }
`;

export const SubStepLabel = styled.li`
  margin-left: 4px;
  margin-top: 14px;
  font-size: 12px;
  color: ${th('colors.black')}80;
  white-space: nowrap;
  list-style: square;
  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
  transition: color 100ms, font-weight 100ms;
  cursor: ${({ $isDone }) => ($isDone ? 'pointer' : 'initial')};

  ${({ $selected, $isDone }) =>
    ($selected || $isDone) &&
    css`
      color: ${th('colors.black')};
    `};
`;
